import React from 'react';

import ManageEvent from './ManageEvent';
import GuestEventOptions from './GuestEventOptions';
import { useEventPageContext } from './context/EventPageContext';

const EventMenu: React.FC = () => {
  const { event } = useEventPageContext();

  return event.isOrganizer || event.isScanner || event.isPhotographer ? (
    <ManageEvent />
  ) : (
    <GuestEventOptions />
  );
};

export default EventMenu;
